<div id="container">
  <div class="title-h2" id="title">
    New Colour
  </div>
  <app-new-colour *ngIf="carManufactuer" [carManufacturer]="carManufactuer" [existingColours]="existingColours"
    (onColourCreation)="newColourCreated($event)" (onCancel)="cancel()"></app-new-colour>
</div>